import api from "./api"; // Import your configured Axios instance

// Generic function that returns CRUD operations for a given entity type
export const createBaseRepositoryService = <T>(endpoint: string) => {
  return {
    // Fetch all records
    getAll: async (): Promise<T[]> => {
      try {
        const response = await api.get(endpoint);
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch data from ${endpoint}`, error);
        throw error;
      }
    },

    // Fetch a single record by ID
    getById: async (id: string): Promise<T> => {
      try {
        const response = await api.get(`${endpoint}/${id}`);
        return response.data;
      } catch (error) {
        console.error(`Failed to fetch record from ${endpoint}`, error);
        throw error;
      }
    },

    // Create a new record
    create: async (data: T): Promise<T> => {
      try {
        const response = await api.post(endpoint, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        return response.data;
      } catch (error) {
        console.error(`Error creating record in ${endpoint}`, error);
        throw error;
      }
    },

    // Update an existing record by ID
    update: async (id: string, data: T): Promise<T> => {
      try {
        const response = await api.put(`${endpoint}/${id}`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        return response.data;
      } catch (error) {
        console.error(`Error updating record in ${endpoint}`, error);
        throw error;
      }
    },

    // Delete a record by ID
    delete: async (id: string, email?: string): Promise<void> => {
      try {
        const url = email
          ? `${endpoint}/${id}?email=${email}`
          : `${endpoint}/${id}`;
        const response = await api.delete(url);
        return response.data;
      } catch (error) {
        console.error(`Error deleting record in ${endpoint}`, error);
        throw error;
      }
    },
  };
};
